import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";

const COLORS = ["#0d9488", "#06b6d4", "#f59e0b", "#8b5cf6", "#ec4899"];

export function ChartWidget({ widget }) {
  const data = Array.isArray(widget.data) ? widget.data : [];
  return (
    <div className="bg-card rounded-xl border border-border p-5 shadow-sm" data-testid={`widget-${widget.widgetKey}`}>
      <h3 className="font-semibold text-foreground mb-4">{widget.title}</h3>
      {data.length === 0 ? (
        <p className="text-sm text-muted-foreground py-12 text-center">No data yet</p>
      ) : (
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={data}>
            <XAxis dataKey="name" tick={{ fontSize: 12 }} />
            <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
            <Tooltip />
            <Bar dataKey="value" radius={[6, 6, 0, 0]}>
              {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
